import { INavigationGuardType } from "@/apps/admin-console/models/INavigationGuardType";
import { RouteName } from "@/apps/admin-console/router/RouteName";
import { store } from "@/apps/admin-console/store";
import { Store } from "vuex";
import { IVuexState } from "@/apps/admin-console/shared-models/IVuex";
import useAdminAccountPersistState from "@/apps/admin-console/hooks/useAdminAccountPersistState";
import DefaultMerchantFlag from "@/apps/admin-console/types/DefaultMerchantFlag";

const isAdminLoggedIn = () => {
  return !!sessionStorage.getItem("PJ_AdminJwt");
};

export const navigationGuardForAdmin = (): INavigationGuardType | boolean => {
  if (isAdminLoggedIn()) {
    sessionStorage.removeItem("PJ_AdminJwt");
    sessionStorage.removeItem("PJ_admin");
    return { name: RouteName.Login };
  }

  return true;
};

export const navigationGuardLoggedIn = (): INavigationGuardType | boolean => {
  return isAdminLoggedIn() ? true : { name: RouteName.Login };
};

export const navigationGuardForDashboardUsers = ():
  | INavigationGuardType
  | boolean => {
  const url = new URLSearchParams(window.location.search);
  if (url.has("adminId") && url.has("token")) {
    const token: string | undefined = url.get("token")?.toString();
    const adminId: string | undefined = url.get("adminId")?.toString();
    sessionStorage.setItem("PJ_AdminJwt", token ?? "");
    sessionStorage.setItem("PJ_admin", adminId ?? "");
    window.location.href = process.env.VUE_APP_APP_URL + "/" + "admin-console";
  }

  return true;
};

export const navigationGuardForModuleDashboard = async (): Promise<
  INavigationGuardType | boolean
> => {
  const vuexStore = store as unknown as Store<IVuexState>;

  await useAdminAccountPersistState();

  return !!vuexStore.state.admin?.adminAccount?.defaultMerchantFlags?.includes(
    DefaultMerchantFlag.ADMIN_USE_DASHBOARD
  );
};

export const navigationGuardForClerkModule = async (): Promise<
  INavigationGuardType | boolean
> => {
  const vuexStore = store as unknown as Store<IVuexState>;

  await useAdminAccountPersistState();

  return !!vuexStore.state.admin?.adminAccount?.defaultMerchantFlags?.includes(
    DefaultMerchantFlag.ADMIN_CLERK_MODULE
  );
};

export const navigationGuardForBillingModule = async (): Promise<
  INavigationGuardType | boolean
> => {
  const vuexStore = store as unknown as Store<IVuexState>;

  await useAdminAccountPersistState();

  return !!vuexStore.state.admin?.adminAccount?.defaultMerchantFlags?.includes(
    DefaultMerchantFlag.ADMIN_BILLING_MODULE
  );
};
